import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onRate, testid, size = "w-4 h-4" }) => (
  <div className="flex items-center gap-1" data-testid={testid} onClick={(e) => e.stopPropagation()}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        data-testid={`${testid}-star-${n}`}
        onClick={(e) => {
          e.stopPropagation();
          onRate(n === value ? 0 : n);
        }}
        aria-label={`Rate ${n} star${n > 1 ? "s" : ""}`}
        className="p-0.5 transition-transform duration-150 hover:scale-125"
      >
        <Star
          className={`${size} transition-colors duration-200 ${
            n <= value ? "text-amber-400 fill-amber-400" : "text-zinc-700 hover:text-zinc-500"
          }`}
        />
      </button>
    ))}
  </div>
);
